module.exports = __webpack_public_path__ + "img/5-2.308bf003.svg";